module.exports = __webpack_public_path__ + "img/lightbulb-on.c8d86b2e.png";